import { createFileRoute } from "@tanstack/react-router"

import { QueryState } from "../components/layout/query-state"
import { ScheduleJobList } from "../components/settings/schedule-job-list"
import { useAuth } from "../hooks/use-auth"
import { useScheduledJobs } from "../services/use-scheduled-jobs"

function SchedulesPage() {
  const auth = useAuth()
  const query = useScheduledJobs()
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  return (
    <QueryState
      isLoading={query.isLoading}
      error={query.error}
      isEmpty={query.data?.length === 0}
      emptyMessage="No code-registered scheduled jobs are available."
    >
      <ScheduleJobList
        jobs={query.data ?? []}
        search={{ filter: search.filter ?? "all", q: search.q ?? "" }}
        canEdit={auth.user?.role === "admin"}
        onSearch={(next) => void navigate({ search: next, replace: true })}
      />
    </QueryState>
  )
}
export const Route = createFileRoute("/settings/schedules/")({ component: SchedulesPage })
